import React from "react";
import { FaFacebookF } from "react-icons/fa";
import { AiOutlineInstagram, AiOutlineTwitter } from "react-icons/ai";
import { BsLinkedin } from "react-icons/bs";
import { IoLogoYoutube } from "react-icons/io";
import { NavLink } from "react-router-dom";

const Footer = () => {
  const date = new Date();
  const years = date.getFullYear();

  return (
    <div className="w-full">
      <footer className="bg-[#800000]">
        <div className="mx-auto w-full pt-5">
          <div className="flex flex-col md:flex-row md:justify-between px-9 py-6 lg:py-2 space-y-5 md:space-y-0">
            
            {/* Company Section */}
            <div className="flex flex-col items-center md:items-start">
              <h2 className="mb-4 text-lg font-semibold text-white uppercase">
                Company
              </h2>
              <ul className="text-white font-md">
                <li className="mb-1">
                  <NavLink to="/" className="hover:text-[#F2DF93] text-sm">
                    Home
                  </NavLink>
                </li>
                <li className="mb-1">
                  <NavLink to="/about-us" className="hover:text-[#F2DF93] text-sm">
                    About Us
                  </NavLink>
                </li>
                <li className="mb-1">
                  <NavLink to="/contact-us" className="hover:text-[#F2DF93] text-sm">
                    Contact Us
                  </NavLink>
                </li>
                <li className="mb-1">
                  <NavLink to="/support" className="hover:text-[#F2DF93] text-sm">
                    Support
                  </NavLink>
                </li>
              </ul>
            </div>

            {/* Support Section */}
            <div className="flex flex-col items-center md:items-start">
              <h2 className="mb-4 text-lg font-semibold text-white uppercase">
                Support
              </h2>
              <ul className="text-white font-medium">
                <li className="mb-1">
                  <NavLink to="/privacy-policy" className="hover:text-[#F2DF93] text-sm">
                    Privacy Policy
                  </NavLink>
                </li>
                <li className="mb-1">
                  <NavLink to="/terms-conditions" className="hover:text-[#F2DF93] text-sm capitalize">
                    Terms & Conditions
                  </NavLink>
                </li>
                <li className="mb-1">
                  <NavLink to="/return-refunds" className="hover:text-[#F2DF93] text-sm">
                    Return & Refunds
                  </NavLink>
                </li>
                <li className="mb-1">
                  <NavLink to="/disclaimer" className="hover:text-[#F2DF93] text-sm">
                    Disclaimer
                  </NavLink>
                </li>
              </ul>
            </div>

            {/* Contact and Social Media Section */}
            <div className="flex flex-col items-center md:items-start">
              <h1 className="mb-4 text-lg font-semibold text-white uppercase">
                Follow Us
              </h1>
              <div className="flex flex-col items-center md:items-start space-y-1">
                <a href="tel:1800123986666" className="text-white font-bold text-sm">
                  1800 12398 6666
                </a>
                <a href="mailto:care@gplusindia.com" className="font-semibold text-white text-sm">
                  care@gplusindia.com
                </a>
              </div>
              <div className="flex justify-center  space-x-3 mt-4">
                <a href="https://www.facebook.com/gplushomeappliances/" className="text-white p-2 rounded-full bg-gray hover:bg-gray-700">
                <FaFacebookF color="#3b5998" size={20} />
                </a>
                <a href="https://www.instagram.com/gplushomeappliances/" className="text-white p-2 rounded-full bg-gray hover:bg-gray-700">
                <AiOutlineInstagram color="#fa7e1e" size={20} />
                </a>
                <a href="https://twitter.com/GplusHome" className="text-white p-2 rounded-full bg-gray hover:bg-gray-700">
                <AiOutlineTwitter color="#00acee" size={20} />
                </a>
                <a href="https://www.linkedin.com/company/gplus-india-home-appliances/" className="text-white p-2 rounded-full bg-gray hover:bg-gray-700">
                <BsLinkedin color="#0072b1" size={20} />
                </a>
                <a href="https://www.youtube.com/@gplushomeappliances" className="text-white p-2 rounded-full bg-gray hover:bg-gray-700">
                <IoLogoYoutube color="red" size={20} />
                </a>
              </div>
            </div>
          </div>

          {/* Footer Bottom */}
          <div className="flex items-center justify-center py-3 bg-[#800000]">
            <span className="text-sm text-white text-center">
              © {years} GPlusIndia. All rights reserved.
            </span>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
















